<template>
  <ADSCardSection
    :isAccordion="true"
    :isLoading="false"
    sectionId="testID"
  >
    <template #header>
      Donor Clinical Information
    </template>
    <template #body>
      <div class="sections">
        <div class="row">
          <div class="col-2">
            <ADSTextInput
              id="disabled-text"
              v-model="bloodType"
              disabled
              label="Blood Type"
            />
          </div>

          <div class="col-2">
            <ADSTextInput
              id="disabled-text"
              v-model="aboSubType"
              disabled
              label="ABO Sub Type"
            />
          </div>

          <div class="col-2">
            <ADSTextInput
              id="disabled-text"
              v-model="rhFactor"
              disabled
              label="RH Factor"
            />
          </div>

          <div class="col-2">
            <ADSTextInput
              v-model="bloodTypeVerified"
              disabled
              label="Blood Type Verified"
            />
          </div> 
        </div>

        <div class="row">
          <div class="col-8">
            <ADSTextInput
              id="disabled-text"
              v-model="exceptionalDistributionReason"
              disabled
              label="Exceptional Distribution Reason"
              class="ExceptionalDistributionReason"
            />
          </div>
        </div>

        <div class="row">
          

          <div class="col-2">
            <ADSTextInput
              id="disabled-text"
              v-model="exceptionalDistribution"
              disabled
              label="Exceptional Distribution"
            />
          </div>

          <div class="col-3">
            <ADSTextInput
              id="disabled-text"
              v-model="exceptionalDistributionReasonOther"
              class="ExceptionalDistributionReasonOther"
              disabled
              label="Exceptional Distribution Reason Other"
            />
          </div>
        </div>

        <!-- <div class="row">
          <div class="col-2">
            <ADSTextInput
              id="disabled-text"
              v-model="exceptionalDistributionReason"
              disabled
              label="Exceptional Distribution Reason"
            />
          </div>

          <div class="col-3">
            <ADSTextInput
              id="disabled-text"
              v-model="exceptionalDistributionReasonOther"
              class="ExceptionalDistributionReasonOther"
              disabled
              label="Exceptional Distribution Reason Other"
            />
          </div>
        </div> -->

        <div class="row">
          <div class="col-2">
            <ADSTextInput
              v-model="exceptionalDistributionReasonTravel"
              disabled
              label="Exceptional Distribution Reason Travel"
            />
          </div>
        </div>
   
    
        <div
          v-if="heightWeightListCombined.length === 0"
        >
          <div class="row">
            <div class="col-2">
              <ADSTextInput
                id="disabled-text"
                disabled
                label="Height"
              />
            </div>

            <div class="col-2">
              <ADSTextInput
                id="disabled-text"
                disabled
                label="Measurement Date"
              />
            </div>

            <div class="col-2">
              <ADSTextInput
                disabled
                label="Weight"
              />
            </div> 

            <div class="col-2">
              <ADSTextInput
                id="disabled-text"
                disabled
                label="Measurement Date"
              />
            </div>
          </div>
        <!-- <div class="row">
          <div class="col-2">
            <div class="fieldName">
              Height
            </div>
            <input
              class="inputDisplay"
              disabled
            >
          </div> 

          <div class="col-2">
            <div class="fieldName">
              Measurement Date
            </div>
            <input
              class="inputDisplay"
              disabled
            >
          </div>

          <div class="col-2">
            <div class="fieldName">
              Weight
            </div>
            <input
              class="inputDisplay"
              disabled
            >
          </div> 

          <div class="col-2">
            <div class="fieldName">
              Measurement Date
            </div>
            <input
              class="inputDisplay"
              disabled
            >
          </div>
        </div> -->
        </div>
        <div
          v-for="( item ) in heightWeightListCombined"
          :key="item"
        >
          <div class="row">
            <div class="col-2">
              <ADSTextInput
                id="disabled-text"
                v-model="item.height"
                disabled
                label="Height"
              />
            </div>

            <div class="col-2">
              <ADSTextInput
                id="disabled-text"
                v-model="item.measurementDateHeight"
                disabled
                label="Measurement Date"
              />
            </div>

            <div class="col-2">
              <ADSTextInput
                v-model="item.weight"
                disabled
                label="Weight"
              />
            </div> 

            <div class="col-2">
              <ADSTextInput
                id="disabled-text"
                v-model="item.measurementDateWeight"
                disabled
                label="Measurement Date"
              />
            </div>
          </div>
        <!-- <div class="row">
          <div class="col-2">
            <div class="fieldName">
              Height
            </div>
            <input
              v-model="item.height"
              class="inputDisplay"
              disabled
            >
          </div> 

          <div class="col-2">
            <div class="fieldName">
              Measurement Date
            </div>
            <input
              v-model="item.measurementDateHeight"
              class="inputDisplay"
              disabled
            >
          </div>

          <div class="col-2">
            <div class="fieldName">
              Weight
            </div>
            <input
              v-model="item.weight"
              class="inputDisplay"
              disabled
            >
          </div> 

          <div class="col-2">
            <div class="fieldName">
              Measurement Date
            </div>
            <input
              v-model="item.measurementDateWeight"
              class="inputDisplay"
              disabled
            >
          </div>
        </div> -->
        </div>
      </div>
    </template>
  </ADSCardSection>
</template>

<script>
import _ from 'lodash';

export default {
  name: "DonorClinicalInformationSection",
  props: {
    patient: {
      type: Object,
      default: null,
    },
    patientBundle: {
      type: Object,
      default: null,
    }
  },
  data() {
    return {
      // livingDonorToDonateTo: this.getLivingDonorToDonateTo( this.patientBundle ),
      // preSelectedRecipient: this.getPreSelectedRecipient( this.patientBundle ),
      // toBeAllocatedToARecipient: this.getToBeAllocatedToARecipient( this.patientBundle ),
      bloodType: this.getBloodType( this.patientBundle ),
      aboSubType: this.getABOSubType( this.patientBundle ),
      rhFactor: this.getRHFactor( this.patientBundle ),
      bloodTypeVerified: this.getBloodTypeVerified( this.patientBundle ),
      exceptionalDistribution: this.getExceptionalDistribution( this.patientBundle ),
      exceptionalDistributionReason: this.getExceptionalDistributionReason( this.patientBundle ),
      exceptionalDistributionReasonOther: this.getExceptionalDistributionReasonOther( this.patientBundle ),
      exceptionalDistributionReasonTravel: this.getExceptionalDistributionReasonTravel( this.patientBundle ),
      //cPRA: this.getCPRA( this.patientBundle ),
      // height: this.getHeight( this.patientBundle ),
      // weight: this.getWeight( this.patientBundle ),
      heightList: this.getHeightList( this.patientBundle ),
      weightList: this.getWeightList( this.patientBundle ),
      heightWeightListCombined: this.getCombinedList( this.getHeightList( this.patientBundle ), this.getWeightList( this.patientBundle ) ),
    };
    },
   mounted() {
    
    },
  methods: {
    combineProps() {
      return `${this.patient}`;
    },
     getBloodType( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
        let bloodType = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#332' ) ) ;
      if( bloodType && bloodType[ 0 ] ) {
        return _.get( bloodType[ 0 ], 'resource.component[0].valueString' );  
      } 
      }
    },
    getABOSubType( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
        const aboSubTypeCodes = [ 'TXP#364', 'TXP#358' ];
        for( const code of aboSubTypeCodes ) {
          let aboSubType = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === code ) ) ;
          const value = _.get( aboSubType?.[ 0 ], 'resource.component[0].valueString' );
          if( value ) {
            return value;
          }
        }
      }
    },
    getRHFactor( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
        let rhFactor = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#333' ) ) ;
      if( rhFactor && rhFactor[ 0 ] ) {
        return _.get( rhFactor[0], 'resource.component[0].valueString' );    
      } 
      }
    },
    getBloodTypeVerified( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
        let bloodTypeVerified = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#359' ) ) ;
      if( bloodTypeVerified && bloodTypeVerified[ 0 ] ) {
        return _.get( bloodTypeVerified[0], 'resource.component[0].valueBoolean' ) ? 'Checked' : 'Unchecked' ;    
      } 
      }
    },
    getExceptionalDistribution( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
        let exceptionalDistribution = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#034' ) ) ;
      if( exceptionalDistribution && exceptionalDistribution[ 0 ] ) {
        return _.get( exceptionalDistribution[0], 'resource.component[0].valueBoolean' ) ? 'Checked' : 'Unchecked' ;    
      } 
      }
    },
    getExceptionalDistributionReason( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
          _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
        if( observation && observation[ 0 ] ) {
          let exceptionalDistributionReason = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#373' ) ) ;
        if( exceptionalDistributionReason && exceptionalDistributionReason[ 0 ] ) {
          let components = _.get( exceptionalDistributionReason[ 0 ], 'resource.component', [] );
          return ( components || [] )
            .map( ( c ) => _.get( c, 'valueString' ) )
            .filter( ( v ) => v !== undefined && v !== null && String( v ).trim() !== '' )
            .join( ', ' );    
        } 
        }
    },
    getExceptionalDistributionReasonOther( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
        let exceptionalDistributionReasonOther = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#374' ) ) ;
      if( exceptionalDistributionReasonOther && exceptionalDistributionReasonOther[ 0 ] ) {
        return _.get( exceptionalDistributionReasonOther[0], 'resource.component[0].valueString' );     
      } 
      }
    },
    getExceptionalDistributionReasonTravel( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
        let exceptionalDistributionReasonTravel = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#401' ) ) ;
      if( exceptionalDistributionReasonTravel && exceptionalDistributionReasonTravel[ 0 ] ) {
        return _.get( exceptionalDistributionReasonTravel[0], 'resource.component[0].valueString' );     
      } 
      }
    },
    // getCPRA( patientBundle ) {
    //   let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[ 0 ], 'resource.resourceType' ) === 'Observation' ) );
    //   if( observation && observation[ 0 ] ) {
    //   let cpra = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.category[0].coding[0].code' ) === 'smartdata' && _.get( n, 'resource.code.coding[0].code' ) === 'TXP#135' ) ) ; 
    //   if( cpra && cpra[0 ]?.resource.code.text ) {
    //     return _.get( cpra[0], 'resource.component[0].valueString' );  
    //   }   
    // }
    // },
    // getHeight( patientBundle ) {
    //   let observation = patientBundle.entries.filter( ( n ) => ( n[ 0 ].resource?.resourceType === 'Observation' ) );
    //   if( observation && observation[ 0 ] ) {
    //   let vitalSigns = observation[ 0 ].filter( ( n ) => ( n.resource?.category[ 0 ].coding[ 0 ].code === 'vital-signs' ) ) ;
    //   if( vitalSigns && vitalSigns[ 0 ] ) {
    //     for( let item of vitalSigns ) {
    //     for( let x of item?.resource?.code?.coding ) {
    //          if( x.code === '8302-2' && x.system === "http://loinc.org" ) {
    //           return item.resource?.valueQuantity?.value + ' ' + item.resource?.valueQuantity?.unit;
    //          }
    //     }
    //   }
    //   }
    //   }
    // },
    getHeightList( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[ 0 ], 'resource.resourceType' ) === 'Observation' ) && 
      _.get( n[ 0 ], 'resource.category[0].coding[0].code' ) === 'vital-signs' );
      if( observation && observation[ 0 ] ) {
      let vitalSigns = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.category[0].coding[0].code' ) === 'vital-signs' ) ) ;
      let heightList = [];
        for( let item of vitalSigns ) {
          if( item?.resource?.code?.coding ) {
        for( let x of item?.resource?.code?.coding ) {
             if( x.code === '8302-2' && x.system === "http://loinc.org" ) {
              heightList.push( { 'height' : item.resource?.valueQuantity?.value + ' ' + item.resource?.valueQuantity?.unit, 'measurementDate' : item.resource?.effectiveDateTime?.substring( 0,10 ) } );
             }
        }
      }
      }
      return heightList;
      }
      return [];
    },
    getWeightList( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[ 0 ], 'resource.resourceType' ) === 'Observation' ) && 
      _.get( n[ 0 ], 'resource.category[0].coding[0].code' ) === 'vital-signs' );   
      if( observation && observation[ 0 ] ) {
      let heightList = [];
        for( let item of observation[ 0 ] ) {
        if( item?.resource?.code?.coding ) {
          for( let x of item?.resource?.code?.coding ) {
             if( x.code === '29463-7' && x.system === "http://loinc.org" ) {
              heightList.push( { 'weight' : item.resource?.valueQuantity?.value + ' ' + item.resource?.valueQuantity?.unit, 'measurementDate' : item.resource?.effectiveDateTime?.substring( 0,10 ) } );
             }
        }
        }
      }
      return heightList;
      }
      return [];
    },
    getCombinedList( heightList, weightList ) {
      let length = heightList.length > weightList.length ? heightList.length : weightList.length;
      let combinedList = [];

      for( let x=0; x<length; x++ ) {
        combinedList.push( { 'height' : _.get( heightList[ x ], 'height', '' ), 'measurementDateHeight' : _.get( heightList[ x ], 'measurementDate', '' ), 
        'weight' : _.get( weightList[ x ], 'weight', '' ), 'measurementDateWeight' : _.get( weightList[ x ], 'measurementDate', '' ) } )
       
      }
      return combinedList;
    },
    // getWeight( patientBundle ) {
    //   let observation = patientBundle.entries.filter( ( n ) => ( n[ 0 ].resource?.resourceType === 'Observation' ) );
    //   if( observation && observation[ 0 ] ) {
    //   let vitalSigns = observation[ 0 ].filter( ( n ) => ( n.resource?.category[ 0 ].coding[ 0 ].code === 'vital-signs' ) ) ;
    //   console.log( 'vitalsigns', vitalSigns )
    //   if( vitalSigns && vitalSigns[ 0 ] ) {
    //     for( let item of vitalSigns ) {
    //     for( let x of item?.resource?.code?.coding ) {
    //          if( x.code === '29463-7' && x.system === "http://loinc.org" ) {
    //           return item.resource?.valueQuantity?.value + ' ' + item.resource?.valueQuantity?.unit;
    //          }
    //     }
    //   }
    //   }
    //   }
    // },
  },
};
</script>

<style scoped>

/* .card {
  height: 340px;
} */

.sectionHeading {
  background-color: rgb(59, 53, 53);
  color: white;
  padding-left: 5px;
}
.page-content .summary-card .card-header .summary-name {
  padding-left: 35px;
  padding-top: 4px;
  font-weight: 300;
}

.sections {
  font-size: 15px;
  height: 520px;
  width: 1400px;
  /* overflow: scroll; */
  padding-left: 10px;
  /* padding-top: 5px; */
}

.inputDisplay {
border-style: solid;
background-color: #F2F2F2;
}

.fieldName {
  font-weight: 700;
  font-size: 0.875rem;
  padding-top: 5.5px;
  padding-bottom: 2.5px;
}

:deep(.afflo-ds-form-control) {
  width: max-content;
}

:deep(label) {
  width: max-content;
}

:deep(.ExceptionalDistributionReason .afflo-ds-form-control) {
  width: 1100px;
}
:deep(.ExceptionalDistributionReasonOther .afflo-ds-form-control) {
  width: 400px;
}

</style>
